var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"elevation":"2","color":"red","icon":""},on:{"click":evt => _vm.$emit('click', evt)}},[_c('v-icon',[_vm._v(" mdi-cancel ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }